/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetSegmentsRangeQueryResponse, SegmentsGetSegmentsRangePathParams, SegmentsGetSegmentsRangeQueryParams, SegmentsGetSegmentsRange400, SegmentsGetSegmentsRange401, SegmentsGetSegmentsRange403, SegmentsGetSegmentsRange404 } from "../models/SegmentsGetSegmentsRange";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { segmentsGetSegmentsRange } from "../axios/segmentsGetSegmentsRange";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const segmentsGetSegmentsRangeQueryKey = (station: SegmentsGetSegmentsRangePathParams["station"], params: SegmentsGetSegmentsRangeQueryParams) => ["api-v2", { url: '/segments/v1/stations/:station/segments', params: {station:station} }, ...(params ? [params] : [])] as const

export type SegmentsGetSegmentsRangeQueryKey = ReturnType<typeof segmentsGetSegmentsRangeQueryKey>

export function segmentsGetSegmentsRangeQueryOptions(station: SegmentsGetSegmentsRangePathParams["station"], params: SegmentsGetSegmentsRangeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = segmentsGetSegmentsRangeQueryKey(station, params)
        return queryOptions<SegmentsGetSegmentsRangeQueryResponse, ResponseErrorConfig<SegmentsGetSegmentsRange400 | SegmentsGetSegmentsRange401 | SegmentsGetSegmentsRange403 | SegmentsGetSegmentsRange404>, SegmentsGetSegmentsRangeQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return segmentsGetSegmentsRange(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns full segment data for the given time range. Optional query flags control whether media URLs, waveform, and I-frame metadata are included.
 * @summary List segments for the specified interval
 * {@link /segments/v1/stations/:station/segments}
 */
export function useSegmentsGetSegmentsRange<TData = SegmentsGetSegmentsRangeQueryResponse, TQueryData = SegmentsGetSegmentsRangeQueryResponse, TQueryKey extends QueryKey = SegmentsGetSegmentsRangeQueryKey>(station: SegmentsGetSegmentsRangePathParams["station"], params: SegmentsGetSegmentsRangeQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SegmentsGetSegmentsRangeQueryResponse, ResponseErrorConfig<SegmentsGetSegmentsRange400 | SegmentsGetSegmentsRange401 | SegmentsGetSegmentsRange403 | SegmentsGetSegmentsRange404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? segmentsGetSegmentsRangeQueryKey(station, params)
         

         const query = useQuery({
          ...segmentsGetSegmentsRangeQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SegmentsGetSegmentsRange400 | SegmentsGetSegmentsRange401 | SegmentsGetSegmentsRange403 | SegmentsGetSegmentsRange404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}